export const urlApi = "https://api-videocall.fynd.com.br"

// export const urlApi = "http://localhost:3002"